<template>
  <div id="lm-date-builder-ui" class="row">
    <LmTextInput
      ref="inputFocus"
      class="col-12 col-md-4"
      v-model="component.componentProps.label"
      @input="onLabelChange($event)"
      :label="$t('title')"
      :placeholder="$t('title')"
      :help="$t('comp_title_help')"
    />
    <LmTextInput
      v-if="validateSuperUser"
      class="col-12 col-md-4"
      v-model="component.formObjectToSendToServerProperty"
      @input="$emit('input', component); $emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
      :label="$t('name')"
      :placeholder="$t('name')"
      :help="$t('comp_name_help')"
    />
    <LmTextInput
      class="col-12 col-md-4"
      v-model="component.componentProps.placeholder"
      @input="$emit('input', component)"
      :label="$t('placeholder')"
      :placeholder="$t('placeholder')"
      :help="$t('comp_placeholder_help')"
    />
    <LmTextInput
      class="col-12 col-md-8"
      :id="id + 'help'"
      v-model="component.componentProps.help"
      @input="$emit('input', component)"
      :label="$t('helper_text_setter')"
      :placeholder="$t('helper_text_setter')"
      :help="$t('helper_text_setter_help')"
    />
    <LmSelect
      :id="id + 'css'"
      class="col-12 col-md-4"
      v-model="component.class"
      :options="{
        content: [
          {value: 'col-12 col-md-3',text: '25%'},
          {value: 'col-12 col-md-6', text: '50%'},
          {value: 'col-12 col-md-9', text: '75%'},
          {value: 'col-12 col-md-12', text: '100%'}
        ]
      }"
      :label="$t('desktop_view_width')"
      :help="$t('help_width_form_element')"
      @input="$emit('input', component)"
    />
    <div class="col-12">
      <h5>{{ $t('settings') }}</h5>
      <div class="row">
        <LmSelect
          class="col-12 col-md-4"
          v-model="component.componentProps.config.minDate"
          :options="minDateOptions"
          :label="$t('comp_min_date')"
          @input="$emit('input', component)"
        />
        <LmSelect
          class="col-12 col-md-4"
          v-model="component.componentProps.config.dateFormat"
          :options="formatOptions"
          :label="$t('comp_format_date')"
          @input="$emit('input', component)"
        />
      </div>
    </div>
    <hr class="w-100 mx-2">
    <div class="col-12">
      <h5>{{ $t('validations') }}</h5>
      <div class="row align-items-center">
        <LmCheckbox
          class="col-12 col-md-4"
          :labelSingle="$t('required')"
          v-model="validations.required"
          @input="$emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
        />
      </div>
    </div>
    <hr class="w-100 mx-2">
    <LmConditionalBuilderUi
      v-if="isVisibleCondition"
      class="col-12"
      :visibilityDependOnConditions="visibilityDependOnConditions"
      :self="component.formObjectToSendToServerProperty"
    />
  </div>
</template>

<script>
import LmSelect from '@/components/form/elements/LmSelect'
import lmFormElementsBuilderUiMixin from '@/mixins/lmFormElementsBuilderUiMixin.js'

import moment from 'moment'
import 'moment/locale/es'
moment.locale('es')

export default {
  mixins: [lmFormElementsBuilderUiMixin],
  components: {
    LmSelect
  },
  data () {
    return {
      validations: {
        required: false
      },
      dateNow: new Date(),
      formatOptions: {
        content: [
          {
            value: 'd-m-Y',
            text: moment(this.dateNow).format('DD-MM-YYYY')
          },
          {
            value: 'Y-m-d',
            text: moment(this.dateNow).format('YYYY-MM-DD')
          },
          {
            value: 'd M Y',
            text: moment(this.dateNow).format('DD MMM YYYY')
          },
          {
            value: 'l d M. Y',
            text: moment(this.dateNow).format('dddd DD MMM YYYY')
          }
        ]
      },
      minDateOptions: {
        content: [
          {
            value: null,
            text: this.$t('none')
          },
          {
            value: 'today',
            text: this.$t('today')
          }
        ]
      }
    }
  },
  props: {
    isVisibleCondition: {
      type: Boolean,
      default: true
    }
  }
}
</script>
